document.addEventListener('input', function (e) {
  const main = document.querySelector('.quantity__group--1 .quantity__input');
  const sticky = document.querySelector('.js-sticky-qty');
  if (main && sticky) sticky.value = main.value || 1;
});
// sincroniza também ao carregar/trocar variante
document.addEventListener('DOMContentLoaded', function(){
  const main = document.querySelector('.quantity__group--1 .quantity__input');
  const sticky = document.querySelector('.js-sticky-qty');
  if (main && sticky) sticky.value = main.value || 1;
});
